import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import MarketAppResource from './MarketAppResource';

class ZipInfoAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'zip-info';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'zipinfos';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'city',
            'state',
            'zip',
            'areaCode',
            'fips',
            'county',
            'pref',
            'timeZone',
            'lat',
            'lng',
            'population',
            'marketUuid',
            'market',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            market: MarketAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            market: 'market_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            city: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            state: {
                type: 'string',
                presence: true,
                length: {
                    is: 2,
                },
            },
            zip: {
                type: 'string',
                presence: true,
                numericality: true,
            },
            areaCode: {
                type: 'string',
                presence: true,
                numericality: true,
            },
            fips: {
                type: 'string',
                presence: true,
                numericality: true,
            },
            county: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            pref: {
                type: 'string',
                presence: true,
                length: {
                    is: 1,
                },
            },
            timeZone: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            lat: {
                presence: true,
                numericality: true,
            },
            lng: {
                presence: true,
                numericality: true,
            },
            population: {
                type: 'integer',
                numericality: true,
            },
            marketUuid: {
                type: 'string',
            },
        };
    }

}

export default ZipInfoAppResource;
